module.exports = __webpack_public_path__ + "static/map_bg_texture_fizz-66efec4ccf9c8f4931b74c95464f7e3f.png";